'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapAction = exports.wrapDispatch = exports.bindActionCreators = undefined;

var _plainMultireducer = require('./plainMultireducer');

var _plainMultireducer2 = _interopRequireDefault(_plainMultireducer);

var _bindActionCreators = require('./bindActionCreators');

var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);

var _wrapDispatch = require('./wrapDispatch');

var _wrapDispatch2 = _interopRequireDefault(_wrapDispatch);

var _wrapAction = require('./wrapAction');

var _wrapAction2 = _interopRequireDefault(_wrapAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bindActionCreators = _bindActionCreators2.default;
exports.wrapDispatch = _wrapDispatch2.default;
exports.wrapAction = _wrapAction2.default;
exports.default = _plainMultireducer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/multireducer/lib/index.js
// module id = 415
// module chunks = 1 2 3